module.exports = __webpack_public_path__ + "static/media/satellite-dish.b3dd7335.svg";